import { Component, Fragment } from 'react'
import each from 'lodash/each'
import Slider from 'react-slick'
import './dc-slider.sass'
import Lightbox from 'react-images'
import Modal from 'react-modal/lib/components/Modal'
import ReactPlayer from 'react-player'

const theme = {
  footerCaption: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '16px',
  },
}

export default class DiveCenterMedia extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentImage: 0,
      photosPopupOpened: false,
      videosPopupOpened: false,
      playing: false,
    }
  }
  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    })
  }

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    })
  }

  gotoImage = (index) => {
    this.setState({
      currentImage: index,
    })
  }

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      photosPopupOpened: false,
    })
  }

  openLightbox = (index) => {
    this.setState({
      currentImage: index,
      photosPopupOpened: true,
    })
  }

  triggerVideoPopup(videosPopupOpened) {
    this.setState({
      videosPopupOpened,
    })
  }

  render() {
    const { playing } = this.state
    const settings = {
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: false,
      arrows: false,
      dots: false,
      responsive: [
        { breakpoint: 768, settings: { arrows: false, slidesToShow: 3.5, slidesToScroll: 3 } },
        { breakpoint: 1025, settings: { arrows: false, slidesToShow: 3.5, slidesToScroll: 3 } },
      ],
    }
    const popupSliderSetting = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
    }

    return (
      <Fragment>
        <Lightbox
          images={this.props.photos}
          currentImage={this.state.currentImage}
          isOpen={this.state.photosPopupOpened}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          width={window.innerWidth * 0.9}
          onClickThumbnail={this.gotoImage}
          showThumbnails
          theme={theme}
          onClose={this.closeLightbox}
        />
        <Slider className='slick-pt-custom same-height' {...settings}>
          {
            this.props.videos.map(video => {
              return (
                <div className='dc-photo' dc-videos='dc-videos' key={video.id} onClick={() => this.triggerVideoPopup(true)}>
                  <img src={video.image} />
                  <i className='font-icons play-icon' />
                </div>
              )
            })
          }
          {
            this.props.photos.map((photo, index) => {
              return (
                <div key={photo.id} className='dc-photo' onClick={() => this.openLightbox(index)}>
                  <img src={photo.thumbnail} />
                </div>
              )
            })
          }
        </Slider>
        { this.state.videosPopupOpened && (
          <Modal
            isOpen={this.state.videosPopupOpened}
            style={{ content: { maxWidth: '730px' } }}
            onRequestClose={() => this.triggerVideoPopup(false)}
            ariaHideApp={false}
            className='Modal react-popup video-popup'
            overlayClassName='Overlay'
            contentLabel='Booking enquire popup'>
            <span className='close-btn' onClick={() => this.triggerVideoPopup(false)} />
            <Slider className='slick-pt-custom mbn' {...popupSliderSetting} afterChange={() => this.setState({
              playing: false,
            })}>
              {
                this.props.videos.map((video) => {
                  return <ReactPlayer url={video.url} key={video.id}
                    width={window.innerWidth < 768 ? `${window.innerWidth * 0.85}px` : '640px'}
                    controls
                    onPause={() => this.setState({ playing: false })}
                    onEnded={() => this.setState({ playing: false })}
                    onPlay={() => this.setState({ playing: video.id })}
                    onStart={() => this.setState({ playing: video.id })}
                    playing={playing === video.id} />
                })
              }
            </Slider>
          </Modal>
        )}
      </Fragment>
    )
  }
}
